import groq from 'groq'
export const ContactFormSectionQuery = groq`
_type == "contactFormSectionType" => {
  "heading": heading->heading,
  ...,

  "CallToAction": *[_type == "page" && slug.current == "digital-dkv"][0].pageBuilder[_type == "CallToAction"] {
        design {
          padding {
            spacingTop,
            spacingBottom
          }
        }
      },

}
`
